export interface CardContentModel {
	key: string;
	value: any;
	label: string;
	order: number;
	valueType: string;
	isPrimaryKey?: boolean;
}
